import Palette from '@/styles/Themes/Palette';
import Screen from '@/styles/Themes/Screen';
import styled, { DefaultTheme } from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius, borders } from '@/styles/Themes/Metrics';
import { CloseIcon } from '@/shared/images/icons/CloseIcon';
import { Redirect } from '@/shared/images/icons/Redirect';
import Text from '@/styles/Themes/Text';

export const ModalWrapper = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
`;

export const ModalContent = styled.div`
    position: relative;
    background-color: ${cssVars.bg_white_dark3};
    border-radius: ${radius.small};
    box-shadow: ${cssVars.shadow_modal};
    width: 340px;
    padding: 20px 30px 30px;
    height: 257px;

    ${Screen.ipad} {
        width: 490px;
        height: 330px;
        padding: 30px 40px 40px;
    }

    ${Screen.desktop} {
        width: 474px;
        height: 345px;
        padding: 47px 50px 50px;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    height: 25px;
    width: 100%;
`;

export const InfoMessage = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    ${Text.Full.medium.regular};
    color: ${Palette.black};
    box-sizing: border-box;

    ${Screen.desktop} {
        padding: 0;
    }

    > svg {
        margin: 0 auto;

        ${Screen.ipad} {
            width: 100px;
            height: 100px;
        }

        ${Screen.desktop} {
            width: 85px;
            height: 85px;
        }
    }
`;

export const YouRedirected = styled.div`
    display: flex;
    justify-content: center;
    padding: 23px 42px 0;
    ${Text.Full.large.medium};

    ${Screen.ipad} {
        padding: 26px 92px 8px;
    }
    ${Screen.desktop} {
        margin: 28px 0 11px;
        padding: 0 60px;
    }
`;

export const WrapperForIcon = styled.div`
    display: flex;
    justify-content: center;
    padding: 5px;
    ${Screen.ipad} {
        padding: 0;
    }
    ${Screen.desktop} {
        padding: 28px 40px 11px;
    }
`;

export const RedirectIcon = styled(Redirect)`
    margin: 0 auto;
`;

export const BtnCancelWrapper = styled.div`
    display: flex;

    > button {
        height: 50px;
        width: 130px;
        color: ${cssVars.fg_gray2_gray3};
        background: transparent;
        border: ${borders.small} ${Palette.gray.gray3};
        ${Text.Full.large.medium};

        ${Screen.ipad} {
            width: 203px;
        }

        ${Screen.desktop} {
            width: 175px;
        }

        &:hover {
            color: ${cssVars.fg_gray2_gray3};
            background: transparent;
        }
    }
`;

export const BtnOkWrapper = styled.div`
    display: flex;

    > button {
        height: 50px;
        width: 130px;
        color: ${Palette.white.normal};
        ${Text.Full.large.medium};

        ${Screen.ipad} {
            width: 203px;
        }

        ${Screen.desktop} {
            width: 175px;
        }
    }
`;

export const Buttons = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 27px 0;

    ${Screen.desktop} {
        padding: 30px 0 0;
    }
`;

export const CloseButtonWithIcon = styled(CloseIcon)``;

interface ICloseIcon extends DefaultTheme {
    onClick: () => void;
}

export const CloseButton = styled.div<ICloseIcon>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background: ${cssVars.bg_ash_normal};
    border-radius: ${radius.huge};
    position: absolute;
    right: 12px;
    top: 12px;
    cursor: pointer;

    ${Screen.ipad} {
        width: 40px;
        height: 40px;
    }

    ${Screen.desktop} {
        width: 36px;
        height: 36px;
    }

    &:hover {
        background: ${cssVars.bg_white_dark3};
        box-shadow: ${cssVars.shadow_card_default};
    }
`;
